import { gql } from "@apollo/client";

export const APP_DATA = gql`
	query AppData($organisationId: ID) {
		hashtags(organisationId: $organisationId)
		labels {
			accommodation {
				_id
				name
				order
				type
			}
			activity {
				_id
				name
				order
				type
			}
			article {
				_id
				name
				order
				type
			}
			cuisine {
				_id
				name
				order
				type
			}
			other {
				_id
				name
				order
				type
			}
			transport {
				_id
				name
				order
				type
			}
		}
		currencies {
			date
			name
			value {
				alphaCode
				code
				inverseRate
				rate
			}
		}
	}
`;
export const IMAGES = gql`
	query Images($country: String, $city: String) {
		images(country: $country, city: $city) {
			id
			owner
			source
			title
			url
		}
	}
`;
export const JOURNAL_IMAGE_LINK = gql`
	query Query($tripId: String, $name: String) {
		generateJournalImageURL(tripId: $tripId, name: $name)
	}
`;
export const USER_PROFILE_IMAGE_LINK = gql`
	query GenerateUserProfileImageURL {
		generateUserProfileImageURL
	}
`;
export const PLACE_IMAGE_LINK = gql`
	query Query($placeId: String) {
		generatePlaceImageURL(placeId: $placeId)
	}
`;
export const DESTINATION_IMAGE_LINK = gql`
	query Query($destinationId: String) {
		generateDestinationImageURL(destinationId: $destinationId)
	}
`;
export const TOP_ACTIVITIES = gql`
	query TopActivities($country: String!, $city: String!) {
		topActivities(country: $country, city: $city) {
			city
			country
			count
			topTitles {
				_id
				address
				city
				country
				description
				googlePlaceId
				googleUrl
				image
				lat
				link
				lng
				logo
				metadata
				normalised_city
				normalised_country
				placeName
				rating
				ratingAmount
				state
				stipplCountry
				title
				type
			}
		}
	}
`;
export const TOP_ACCOMMODATIONS = gql`
	query TopAccommodations($country: String!, $city: String!) {
		topAccommodations(country: $country, city: $city) {
			city
			country
			count
			topTitles {
				_id
				address
				city
				country
				description
				googlePlaceId
				googleUrl
				image
				lat
				link
				lng
				logo
				metadata
				normalised_city
				normalised_country
				placeName
				rating
				ratingAmount
				state
				stipplCountry
				title
				type
			}
		}
	}
`;
export const TOP_CUISINE = gql`
	query TopCuisine($country: String!, $city: String!) {
		topCuisine(country: $country, city: $city) {
			city
			country
			count
			topTitles {
				_id
				address
				city
				country
				description
				googlePlaceId
				googleUrl
				image
				lat
				link
				lng
				logo
				metadata
				normalised_city
				normalised_country
				placeName
				rating
				ratingAmount
				state
				stipplCountry
				title
				type
			}
		}
	}
`;

export const PDF_EXPORT_STATUS = gql`
	query PdfExportStatus($jobId: ID!) {
		pdfExportStatus(jobId: $jobId) {
			jobId
			status
			pdfUrl
			error
			createdAt
			completedAt
		}
	}
`;

export const TRIP_PDF_CACHE = gql`
	query TripPdfCache($tripId: ID!) {
		tripPdfCache(tripId: $tripId) {
			tripId
			pdfUrl
			status
			renderedAt
			tripUpdatedAt
		}
	}
`;
